import "@arco-design/web-react/es/ConfigProvider/style";
import _ConfigProvider from "@arco-design/web-react/es/ConfigProvider";
import "@arco-design/web-react/es/Modal/style";
import _Modal from "@arco-design/web-react/es/Modal";
import "@arco-design/web-react/es/Message/style";
import _Message from "@arco-design/web-react/es/Message";
import './style/global.less';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import zhCN from '@arco-design/web-react/es/locale/zh-CN';
import enUS from '@arco-design/web-react/es/locale/en-US';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import axios from 'axios';
import rootReducer from './store';
import PageLayout from './layout';
import { GlobalContext } from './context';
import Login from './pages/login';
import checkLogin from './utils/checkLogin';
import changeTheme from './utils/changeTheme';
import useStorage from './utils/useStorage';
import './utils/interceptor';
import constant from '@/utils/constant';
import { ConditionMchAgentSet, GetSySConfig } from '@/utils/service';
import { initVChartArcoTheme } from '@visactor/vchart-arco-theme';
initVChartArcoTheme();
const store = createStore(rootReducer);

function Index() {
  const [lang, setLang] = useStorage('arco-lang', 'zh-CN');
  const [theme, setTheme] = useStorage('arco-theme', 'light');

  function getArcoLocale() {
    switch (lang) {
      case 'zh-CN':
        return zhCN;

      case 'en-US':
        return enUS;

      default:
        return zhCN;
    }
  }

  function fetchUserInfo() {
    store.dispatch({
      type: 'update-userInfo',
      payload: {
        userLoading: true
      }
    });
    axios.get('/tp/user/my').then(({
      data
    }) => {
      if (data.code === constant.SysSuc) {
        localStorage.setItem('userRole', data.data.role || 0);
        store.dispatch({
          type: 'update-userInfo',
          payload: {
            userInfo: data.data,
            userLoading: false
          }
        });
        if (data.data.role == constant.RoleMch) fetchMchSetInfo();
      }
    });
  }

  function fetchMchSetInfo() {
    ConditionMchAgentSet({}, {
      pageSize: 100,
      current: 1
    }).then(res => {
      if (res.data) {
        const {
          code,
          data,
          pageInfo,
          msg
        } = res.data;

        if (code === constant.SysSuc) {
          store.dispatch({
            type: 'update-sets',
            payload: {
              sets: data
            }
          });
        }
      }
    });
  }

  const getConfigs = () => {
    GetSySConfig().then(res => {
      const {
        code
      } = res.data;

      if (code === constant.SysSuc) {
        const {
          data
        } = res.data;
        const payProducts = [];
        const payChannels = [];
        const vBanks = [];
        const eCommerces = [];
        const joinTips = [];
        const transCost = [];
        let smsChannel = {};

        for (const i in data) {
          if (data[i].team == 'pay-product') payProducts.push(data[i]);
          if (data[i].team == 'pay-channel') payChannels.push(data[i]);
          if (data[i].team == 'v-bank') vBanks.push(data[i]);
          if (data[i].team == 'e-commerce') eCommerces.push(data[i]);
          if (data[i].team == 'trans-cost') transCost.push(data[i]);
          if (data[i].team == 'sms') smsChannel = data[i];

          if (data[i].team == 'version') {
            if (data[i].status) {
              if (data[i].val != constant.version) {
                _Message.warning({
                  content: `系统后台已更新至最新版本v${data[i].val} 当前版本v${constant.version} 请点击 Ctrl + Shift + R 刷新浏览器缓存!`,
                  duration: 100000
                });
              }
            }
          }

          if (data[i].team == 'system-tip') {
            const showTip = () => {
              if (data[i].val) {
                try {
                  const tipDetail = JSON.parse(data[i].val);

                  if (store.getState().userInfo.incomeInfo) {
                    if (tipDetail.role) {
                      if (tipDetail.role !== store.getState().userInfo.role) {
                        return;
                      }
                    }

                    if (tipDetail.cnl) {
                      if (store.getState().userInfo.incomeInfo.cnlTag !== tipDetail.cnl) {
                        return;
                      }
                    }

                    if (tipDetail.bankCode) {
                      if (store.getState().userInfo.incomeInfo.bankCode !== tipDetail.bankCode) {
                        return;
                      }
                    }

                    _Modal.info({
                      title: tipDetail.title,
                      // 标题
                      okText: '我已知晓',
                      onCancel: undefined,
                      content: /*#__PURE__*/React.createElement("div", {
                        style: {
                          whiteSpace: 'pre-wrap'
                        }
                      }, /*#__PURE__*/React.createElement("span", null, tipDetail.content)),
                      // 内容
                      onOk: () => {// 点击确定按钮后的回调
                      },
                      maskClosable: false
                    });
                  }
                } catch (e) {
                  console.log(e);
                }
              }
            };

            if (store.getState().userLoading == true) {
              const unsubscribe = store.subscribe(() => {
                const value = store.getState().userLoading;

                if (value == false) {
                  unsubscribe();
                  showTip();
                }
              });
            } else {
              showTip();
            }
          }

          if (data[i].team == 'join-tip') {
            data[i].val = JSON.parse(data[i].val);
            joinTips.push(data[i]);
          }
        }

        store.dispatch({
          type: 'get-configs',
          payload: {
            products: payProducts,
            channels: payChannels,
            vbanks: vBanks,
            joinTips,
            transCost,
            eCommerces,
            smsChannel
          }
        });
      }
    });
  };

  useEffect(() => {
    if (checkLogin()) {
      fetchUserInfo();
      getConfigs();
    } else if (window.location.pathname.replace(/\//g, '') !== 'login') {
      window.location.pathname = '/login';
    }
  }, []);
  useEffect(() => {
    changeTheme(theme);
  }, [theme]);
  const contextValue = {
    lang,
    setLang,
    theme,
    setTheme
  };
  return /*#__PURE__*/React.createElement(BrowserRouter, null, /*#__PURE__*/React.createElement(_ConfigProvider, {
    locale: getArcoLocale(),
    componentConfig: {
      Card: {
        bordered: false
      },
      List: {
        bordered: false
      },
      Table: {
        border: false
      }
    }
  }, /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(GlobalContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: "/login",
    component: Login
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/",
    component: PageLayout
  }))))));
}

ReactDOM.render( /*#__PURE__*/React.createElement(Index, null), document.getElementById('root'));